import { create } from 'zustand'

interface useUIStore {
  affixStatus: boolean;
  updateAffixStatus: (newVal: boolean) => void;
}

const useUIStore = create<useUIStore>((set) => ({
  affixStatus: false,
  updateAffixStatus: (newVal: boolean) => {
    set({ affixStatus: newVal })
  }
}))

export default useUIStore;
